import React, { useState, useEffect } from 'react';
import { TextField, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
import '../Css/Formcontacto.css';

const FormContacto = () => {
    const location = useLocation();
    const property = location.state?.property;

    const [formDataContacto, setFormDataContacto] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        consulta: property
            ? `Estoy interesado/a en la propiedad: \nTítulo: ${property.titulo}\nUbicación: ${property.ubicacion}\nPrecio: ${property.precio} ${property.moneda}`
            : '',
    });

    const [formDataTasacion, setFormDataTasacion] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        descripcion: '',
    });

    const [mensajeContacto, setMensajeContacto] = useState('');
    const [mensajeTasacion, setMensajeTasacion] = useState('');

    useEffect(() => {
        if (property) {
            setFormDataContacto((prevData) => ({
                ...prevData,
                consulta: `Estoy interesado/a en la propiedad: \nUbicación: ${property.ubicacion}\nPrecio: ${property.precio} ${property.moneda}`,
            }));
        }
    }, [property]);

    const handleChangeContacto = (e) => {
        const { name, value } = e.target;
        setFormDataContacto({ ...formDataContacto, [name]: value });
    };

    const handleChangeTasacion = (e) => {
        const { name, value } = e.target;
        setFormDataTasacion({ ...formDataTasacion, [name]: value });
    };

    const handleSubmit = async (e, tipoFormulario) => {
        e.preventDefault();

        let formData = tipoFormulario === 'contacto' ? formDataContacto : formDataTasacion;

        try {
            const response = await fetch('https://backend-admin-nine.vercel.app/api/email/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ...formData, formType: tipoFormulario }),
            });

            if (response.ok) {
                if (tipoFormulario === 'contacto') {
                    setMensajeContacto('Gracias por su consulta. Será contactado a la brevedad.');
                    setFormDataContacto({ nombre: '', apellido: '', telefono: '', email: '', consulta: '' });
                } else {
                    setMensajeTasacion('Gracias por su consulta. Será contactado a la brevedad.');
                    setFormDataTasacion({ nombre: '', apellido: '', telefono: '', email: '', descripcion: '' });
                }
            } else {
                const mensajeError = 'Hubo un error al enviar. Por favor, inténtelo de nuevo.';
                tipoFormulario === 'contacto' ? setMensajeContacto(mensajeError) : setMensajeTasacion(mensajeError);
            }
        } catch (error) {
            console.error(error);
            const mensajeError = 'Error de red al enviar el formulario.';
            tipoFormulario === 'contacto' ? setMensajeContacto(mensajeError) : setMensajeTasacion(mensajeError);
        }
    };

    return (
        <div>
            <div className='inf-contacto'>
                <div className="info-contacto">
                    <h2>Información de Contacto</h2>
                    <p><FaMapMarkerAlt /> Dirección: Dr. Enrique Finochieto 484. Barracas, CABA.</p>
                    <p><FaEnvelope /> Email: <a href="mailto:cancemipropiedades@gmail.com">cancemipropiedades@gmail.com</a></p>
                    <p><FaPhone /> Teléfono: <a href="tel:1133061010">11-3306-1010</a></p>
                </div>
            </div>

            <div id="contacto-forms">

                {/* Contacto */}
                <div id="contacto-box" className="contacto-forms-box">
                    <div className="contacto-forms-titulo">
                        <img src="https://static.tokkobroker.com/tfw/img/mail.44660016f743.svg" alt="Contacto" /><br />Contacto
                    </div>
                    {mensajeContacto && <div className="form-box">{mensajeContacto}</div>}
                    <div className="form-box" id="fields_contact">
                        <TextField fullWidth label="Nombre" name="nombre" value={formDataContacto.nombre} onChange={handleChangeContacto} required margin="normal" />
                        <TextField fullWidth label="Apellido" name="apellido" value={formDataContacto.apellido} onChange={handleChangeContacto} required margin="normal" />
                        <TextField fullWidth label="Teléfono" name="telefono" value={formDataContacto.telefono} onChange={handleChangeContacto} required margin="normal" />
                        <TextField fullWidth label="Correo Electrónico" name="email" value={formDataContacto.email} onChange={handleChangeContacto} type="email" required margin="normal" />
                        <TextField fullWidth label="Dejanos tu Consulta" name="consulta" value={formDataContacto.consulta} onChange={handleChangeContacto} required margin="normal" multiline rows={4} />
                        <Button style={{ backgroundColor: '#27337f' }} type="submit" variant="contained" fullWidth onClick={(e) => handleSubmit(e, 'contacto')}>
                            Enviar Consulta
                        </Button>
                    </div>
                </div>

                {/* Tasaciones */}
                <div id="tasar-box" className="contacto-forms-box">
                    <div className="contacto-forms-titulo">
                        <img src="https://static.tokkobroker.com/tfw/img/supcub2.a4947f6983bb.svg" alt="Tasaciones" /><br />Tasaciones
                    </div>
                    {mensajeTasacion && <div className="form-box">{mensajeTasacion}</div>}
                    <div className="form-box" id="fields_cot">
                        <TextField fullWidth label="Nombre" name="nombre" value={formDataTasacion.nombre} onChange={handleChangeTasacion} required margin="normal" />
                        <TextField fullWidth label="Apellido" name="apellido" value={formDataTasacion.apellido} onChange={handleChangeTasacion} required margin="normal" />
                        <TextField fullWidth label="Teléfono" name="telefono" value={formDataTasacion.telefono} onChange={handleChangeTasacion} required margin="normal" />
                        <TextField fullWidth label="Correo Electrónico" name="email" value={formDataTasacion.email} onChange={handleChangeTasacion} type="email" required margin="normal" />
                        <TextField fullWidth label="Descripción de la Propiedad" name="descripcion" value={formDataTasacion.descripcion} onChange={handleChangeTasacion} required margin="normal" multiline rows={4} />
                        <Button style={{ backgroundColor: '#27337f' }} type="submit" variant="contained" fullWidth onClick={(e) => handleSubmit(e, 'tasacion')}>
                            Enviar Solicitud de Tasación
                        </Button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default FormContacto;
